import { apiClient } from './apiClient';

export interface BlacklistItem {
  id: number;
  symbol: string;
  createdAt: string;
}

export interface AddToBlacklistRequest {
  symbol: string;
}

export class BlacklistService {
  /**
   * 添加币种到黑名单
   */
  async addToBlacklist(symbol: string): Promise<any> {
    const response = await apiClient.post<any>('/blacklist/add', {
      symbol,
    });

    if (!response.success) {
      throw new Error(response.message || '添加黑名单失败');
    }

    return response.data;
  }

  /**
   * 从黑名单中移除币种
   */
  async removeFromBlacklist(symbol: string): Promise<any> {
    const response = await apiClient.delete<any>('/blacklist/remove', {
      data: {
        symbol,
      },
    });

    if (!response.success) {
      throw new Error(response.message || '移除黑名单失败');
    }

    return response.data;
  }

  /**
   * 获取黑名单列表
   */
  async getBlacklist(): Promise<BlacklistItem[]> {
    const response = await apiClient.get<BlacklistItem[]>('/blacklist');

    if (!response.success) {
      throw new Error(response.message || '获取黑名单失败');
    }

    return response.data || [];
  }

  /**
   * 检查币种是否在黑名单中
   */
  async checkIsBlacklisted(symbol: string): Promise<boolean> {
    try {
      const response = await apiClient.get<{ isBlacklisted: boolean }>('/blacklist/check', {
        params: {
          symbol,
        },
      });

      if (!response.success) {
        return false;
      }

      return response.data?.isBlacklisted || false;
    } catch (error: any) {
      console.error('检查黑名单失败:', error);
      return false;
    }
  }
}

export const blacklistService = new BlacklistService();
